import React, { useState } from "react";
import { Dropdown, Form } from "react-bootstrap";
import { ThreeDotIcon } from "../../../assets/svg";

function CustomDropdown({ setMainSearchInText, suggestWord }) {
  const [searchInText, setSearchInText] = useState(false);

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
    </a>
  ));

  // forwardRef again here!
  // Dropdown needs access to the DOM of the Menu to measure it
  const CustomMenu = React.forwardRef(
    ({ children, style, className, "aria-labelledby": labeledBy }, ref) => {
      const [value, setValue] = useState("");

      return (
        <div
          ref={ref}
          style={style}
          className={className}
          aria-labelledby={labeledBy}
        >
          <ul className="list-unstyled">
            {React.Children.toArray(children).filter(
              (child) =>
                !value || child.props.children.toLowerCase().startsWith(value)
            )}
          </ul>
        </div>
      );
    }
  );

  return (
    <Dropdown>
      <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
        <ThreeDotIcon height={"60px"} width={"35px"} color={"white"} />
      </Dropdown.Toggle>

      <Dropdown.Menu as={CustomMenu}>
        <Dropdown.Item eventKey="1">
          <label
            onClick={() => {
              setSearchInText(!searchInText);
              setMainSearchInText(!searchInText);
            }}
          >
            <input type="checkbox" checked={searchInText} />
            &nbsp; Metin içi Arama
          </label>
        </Dropdown.Item>
        <Dropdown.Item eventKey="2">
          <label
            onClick={() => {
              suggestWord();
            }}
          >
            Rastgele Kelime Getir
          </label>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default CustomDropdown;
